import axios, { Axios } from "axios";
import { json } from "react-router-dom";
import axiosInstance from "src/hooks/axios-interceptor";
import { getServerInfo } from "src/util/auth";

//ASSET

export const CreateTicket = (body) => {
  return axiosInstance
    .post(`/createNewTicket`, body)
    .then((response) => {
      return response.data.response[0];
    })
    .catch((error) => {
      var response = catchAxiosError(error);
       return response;
    });
};

export const CreateMntOperator = (body) => {
  return axiosInstance
    .post(`/mntOperator/createNewMntOperator`, body)
    .then((response) => {
      return response.data.response[0];
    })
    .catch((error) => {
      var response = catchAxiosError(error);
       return response;
    });
};

export const fetchTicketStatus = (data) => {
  return axiosInstance
    .post(`/ticket/getAllTicketsByCriteria`, data)
    .then((response) => {
      return response.data.response;
    })
    .catch((error) => {
      var response = catchAxiosError(error);
       return response;
    });
};

export const getAllAlarms = () => {
  return axiosInstance
    .post(`/alarm/getAllAlarmsByCriteria`, {})
    .then((response) => {
      return response.data.response;
    })
    .catch((error) => {
      var response = catchAxiosError(error);
       return response;
    });
};

export const updateTicketStatus = (body) => {
  return axiosInstance
    .post(`/statusProgressForTicket/${body.id}`, body)
    .then((response) => {
      return response.data.response[0];
    })
    .catch((error) => {
      var response = catchAxiosError(error);
       return response;
    });
};

export const UpdateTicket = (body) => {
  return axiosInstance
    .put(`/ticket/${body.id}`, body)
    .then((response) => {
      return response.data.response[0];
    })
    .catch((error) => {
       var response = catchAxiosError(error);
       return response;
    });
};

export const ReassignTicket_ = (body,id) => {
  return axiosInstance
    .put(`/ticket/ticketReassign/${id}`, body)
    .then((response) => {
      return response.data.response[0];
    })
    .catch((error) => {
       var response = catchAxiosError(error);
       return response;
    });
};

export const deleteTicket = (id) => {
  return axiosInstance
    .delete(`/ticket/${id}`)
    .then((response) => {
      return response.data.response[0];
    })
    .catch((error) => {
      catchAxiosError(error);
    });
};

export const getTicket = (id) => {
  return axiosInstance
    .get(`/ticket/${id}`)
    .then((response) => {
      return response.data.response[0];
    })
    .catch((error) => {
      catchAxiosError(error);
    });
};

export const getAllTickets = () => {
  return axiosInstance
    .get(`/getAllTickets`)
    .then((response) => {
      return response.data.response;
    })
    .catch((error) => {
      catchAxiosError(error);
    });
};

export const getAllTicketsByCriteria = (body) => {
  return axiosInstance
    .get(`ticket/getAllTicketsByCriteria`,body)
    .then((response) => {
      return response.data.response;
    })
    .catch((error) => {
      catchAxiosError(error);
    });
};

export const getAllTicketOperators = (id) => {
  return axiosInstance
    .get(`/ticket/getAllMntOperatorsForTicket/${id}`)
    .then((response) => {
      return response.data.response;
    })
    .catch((error) => {
      catchAxiosError(error);
    });
};

export const getAllOperators = () => {
  return axiosInstance
    .get(`/mntOperator/getAllMntOperators`)
    .then((response) => {
      return response.data.response;
    })
    .catch((error) => {
      catchAxiosError(error);
    });
};

export const getReport = () => {
  const [url, token] = getServerInfo();
  return axios
    .get(`${url}/ticket/generateMaintenanceReportPdf/1`, {responseType: 'blob'}, {
      headers: {
        Authorization: `Bearer ${token}`,
      }
    }
 )
    .then((response) => {
      window.open(URL.createObjectURL(response.data));
    })
    .catch((error) => {
      catchAxiosError(error);
    });
};

export const getReportDetail = (id) => {
  const [url, token] = getServerInfo();
  return axios
    .get(`${url}/ticket/generateMaintenanceReportDetailPdf/${id}`, {responseType: 'blob'}, {
      headers: {
        Authorization: `Bearer ${token}`,
      }
    }
 )
    .then((response) => {
      window.open(URL.createObjectURL(response.data));
    })
    .catch((error) => {
      catchAxiosError(error);
    });
};


export const getCostsOfAllTicketsBySiteId = (id) => {
  return axiosInstance
    .get(`/ticket/getCostsOfAllTicketsBySiteId/${id}`)
    .then((response) => {
      return response.data.response[0];
    })
    .catch((error) => {
      catchAxiosError(error);
    });
};

export const getCostsOfAllTicketsByOrgId = () => {
  return axiosInstance
    .get(`/ticket/getMaintenanceReport/${1}`)
    .then((response) => {
      return response.data.response;
    })
    .catch((error) => {
      catchAxiosError(error);
    });
};

export const getCostsOfAllTicketsByAssetId = (id) => {
  return axiosInstance
    .get(`/ticket/getMaintenanceReportDetail/${id}`)
    .then((response) => {
      return response.data.response;
    })
    .catch((error) => {
      catchAxiosError(error);
    });
};


/**ALARM FILTER */
export const fetchAlarmsWithFilter = (body) => {
  return axiosInstance
    .post(`/alarm/getAllAlarmsByCriteria`,body)
    .then((response) => {
      return response.data.response;
    })
    .catch((error) => {
      catchAxiosError(error);
    });
};

//private methods

const catchAxiosError = (error) => {
  if (!error.response) {
    // network error
    return json(
      {},
      {
        status: 404,
      }
    );
  } else {
    const code = error.response.status;
    const message = error.message;
    return { errors:[message]}
  }
};
